import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/return-refund/components/client.tsx");
